<template>
  <b-card header-tag="header">
    <h3 slot="header">Application</h3>
    <h3 v-if="isLoading">Getting your application...</h3>
    <div class="card-text" v-if="isLoaded">
      <h5 v-if="isNewApp && !profileIncomplete && !completed">Welcome! Let's get started.</h5>
      <h5 v-if="isNewApp && profileIncomplete">Welcome! Fill out your profile so we can start your application</h5>
      <div v-if="completed" class="row">
        <div class="col">
          <h2 class="mb-2">Thank You For Applying!</h2>
          <p>You have successfully applied to the SIGGRAPH Student Volunteer Program.</p>
          <p>To ensure accurate registration, make sure <router-link to="/profile">your profile</router-link> is kept up to date.</p>
          <h3>Notification of Acceptance</h3>
          <p>The first group of accepted applications will be sent in early May 2024. Be sure to check your spam settings to ensure you a receiving emails from us.</p>
        </div>
      </div>
      <div v-else>
        <h5 v-if="isNotNewApp">Application in Progress</h5>
        <div class="row">
          <div class="col">
            <b-progress v-if="isNotNewApp" height="2rem" :value="getProgress" show-progress class="mb-2"></b-progress>
            <button v-if="isNotNewApp" type="button" @click="goToApp" class="btn arrow-btn-primary btn-lg arrow-btn-black">Continue Application</button>
            <button v-if="isNewApp && !profileIncomplete" type="button" @click="goToApp" class="btn arrow-btn-primary btn-lg arrow-btn-black">Start Application</button>
            <button v-if="isNewApp && profileIncomplete" type="button" @click="goToProfile" class="btn arrow-btn-primary btn-lg arrow-btn-black">Update Profile</button>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import router from '@/router'

  export default {
    name: 'SvLiveAppStatus',
    data () {
      return {
        appBtnDisabled: false
      }
    },
    computed: {
      ...mapGetters('application', ['getProgress', 'isNewApp', 'isNotNewApp']),
      ...mapGetters('user', ['profileIncomplete']),
      ...mapState('application', ['isLoaded', 'isLoading', 'completed', 'teamLeader'])
    },
    methods: {
      goToApp (e) {
        e.preventDefault()
        router.push('/application/' + this.$store.state.application.step.toString())
      },
      goToProfile (e) {
        e.preventDefault()
        router.push('/profile')
      }
    },
    created: function () {
      if (!this.$store.state.application.isLoaded) {
        this.$store.dispatch('application/load')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LiveAppStatus.vue